import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { UserIsAuthenticated, UserIsVerified } from '../utils/auth';
import { push } from 'react-router-redux';
import { loadBFWOffers,
  loadBFWOffersFeatured,
  openSignupFormRequest,
  openLoginFormRequest
} from '../actions';
import DocumentMeta from 'react-document-meta';
import BFWFeaturedOffersSection from '../components/bfwOffers/BFWFeaturedOffersSection';
import BFWOffersSection from '../components/bfwOffers/BFWOffersSection';

class BFWOffers extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.loadBFWOffers();
    this.props.loadBFWOffersFeatured();
  }

  openAuthModal = (e) => {
    e.preventDefault()
    this.props.openLoginFormRequest();
  }

  render() {
    if (!this.props.bfwOffersFeatured.isLoaded) {
      return <span />
    }

    if (!this.props.bfwOffers.isLoaded) {
      return <span />
    }

    let {offers, auth} = this.props

    let offersDisplay = 'none';
    let loginBtnDisplay = 'block';
    if (auth.user == null) {

    } else {
      offersDisplay = 'block';
      loginBtnDisplay = 'none';
    }


    const meta = {
        title: 'WorldWideWomen | Buy from Women Owned Businesses',
        description: 'Buy from Women Owned Businesses',
    }
    return(
      <div className="content-wrapper">
        <DocumentMeta {...meta} />
        <div className="buyFromWomen-bannerWrapper">
          <div className="buyFromWomen-bannerImage">
            <img className="buyFromWomen-desktop" src="/images/buy_from_women/banner/desktop/banner.jpg" />
            <img className="buyFromWomen-tablet" src="/images/buy_from_women/banner/tablet/banner.jpg" />
            <img className="buyFromWomen-mobile" src="/images/buy_from_women/banner/mobile/banner.jpg" />
          </div>
          <div className="buyFromWomen-bannerTagWrapperOuter">
            <div className="buyFromWomen-bannerTagWrapper">
              BuyFromWomen<sup className="bfw-tm">TM</sup>
            </div>
            <div className="buyFromWomen-bannerSubTagWrapper">
              Purchase goods and services from women-owned businesses
            </div>
          </div>
          <div className="buyFromWomen-bfwLogoOverlay">
            <img src="/images/buy_from_women/buy_from_women_overlay2.png" />
          </div>
        </div>

        <div className="BFWOffers-wrapper">
          <div className="BFWOffers-loginBtnWrapper" style={{display: loginBtnDisplay}}>
            <h1 className="page-header">Sign up or log in to enjoy special offers from women business owners!</h1>
            <button onClick={this.openAuthModal} className="sharedStory-button submitButton button-primary bfwOfferBtn">See my offers</button>
          </div>

          <div className="BFWOffers-wrapperInner" style={{display: offersDisplay}}>
            <h1 className="page-header">Find great deals and discounts from our women owned businesses</h1>
            <BFWFeaturedOffersSection
              bfwOffersFeatured = {this.props.bfwOffersFeatured}
            />

            <BFWOffersSection
              bfwOffers = {this.props.bfwOffers}
            />
          </div>

        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(mapStateToProps, {
  push,
  loadBFWOffers,
  loadBFWOffersFeatured,
  openSignupFormRequest,
  openLoginFormRequest
})(BFWOffers);



// WEBPACK FOOTER //
// ./src/containers/BFWOffers.jsx